import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import {
    defaultLocale,
    supportedLocales
} from '../../../features/settings/state/settings.store';
import { UserSettingsQuery } from '../../../features/user-settings/state/user-settings.query';
import { switchMap, take, filter } from 'rxjs/operators';
import { from } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocaleService {
    constructor(private userSettingsQuery: UserSettingsQuery) {
        this.userSettingsQuery
            .selectLoading()
            .pipe(
                filter((loading) => !loading),
                switchMap((_) => this.userSettingsQuery.selectGlobalSetting$('LOCALE')),
                take(1)
            )
            .subscribe((culture) => {
                const locale = culture.substring(0, culture.indexOf('-')) || culture;
                // check support for locale...
                if (
                    supportedLocales.indexOf(culture === 'en-GB' ? culture : locale) > -1
                ) {
                    // ...and load it if supported
                    this.localeInitializer$(culture === 'en-GB' ? culture : locale);
                } else {
                    // ...or load default locale
                    this.localeInitializer$(defaultLocale);
                }
            });
    }

    private async _localeInitializer(localeId: string): Promise<any> {
        const module = await import(
            /* webpackInclude: /(no|nb|sv|fi|da|en-GB|en)\.mjs$/ */
            `/node_modules/@angular/common/locales/${localeId}.mjs`
        );
        return registerLocaleData(module.default);
    }

    localeInitializer$(localeId: string) {
        return from(this._localeInitializer(localeId).then(() => localeId));
    }
}
